<template>
  <div class="card py4 white_background">
    <RouterLink :to="buttonRoute" class="mt2 welcome-button">{{ buttonText }}</RouterLink>

    <img
      class="center"
      style="width: 100px; margin: auto; display: block"
      src="https://res.cloudinary.com/helloguest/image/upload/v1587637638/Image_from_iOS.jpg"
    />

    <h1 class="center_text bold medium mb1 mt0">
      {{ $t('cms.welcome.title') }}
    </h1>

    <p class="small center_text action">
      {{ $t('cms.welcome.subtitle') }}
    <p/>
  </div>
</template>

<script>

export default {
  name: 'welcome-card',

  props: {
    buttonRoute: Object,
    buttonText: String,
  },
};
</script>


<style lang="scss" scoped>
.welcome-button {
  display: block;
  margin-left: auto;
  margin-right: 0;
  margin-bottom: -36px;
  width: 75px;
  text-align: center;
  color: black;
  font-weight: 700;
  padding: 4px 0;
  border-radius: $border_radius;
  border: solid 1px black;
  background-color: $color_secondary;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
